import { __decorate, __metadata } from "tslib";
import { Utils } from "../../Utils";
import NeoModel from "../../Model/NeoModel";
import { Observable } from "../../Model/Decorators";
var FileUploadBatch = /** @class */ (function () {
    function FileUploadBatch(files) {
        this.recordIndex = {};
        this.key = Utils.uuidv4();
        this.uploadPercent = 0;
        this.isComplete = false;
        this.uploadError = null;
        this.files = Array.from(files);
    }
    Object.defineProperty(FileUploadBatch.prototype, "totalSize", {
        get: function () {
            return this.files.reduce(function (p, c) { return p + c.size; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a record of T for each file in this batch.
     * @param recordType Record type to create.
     * @param fileDescriptorKey Property name of a property which returns a file descriptor.
     * @param fileDescriptorType File descriptor type of your project.
     * @param options Additional options.
     */
    FileUploadBatch.prototype.createRecords = function (recordType, fileDescriptorKey, fileDescriptorType, options) {
        options = options !== null && options !== void 0 ? options : {};
        var records = [];
        for (var _i = 0, _a = this.files; _i < _a.length; _i++) {
            var file = _a[_i];
            var fileDescriptor = new fileDescriptorType();
            fileDescriptor.fileName = file.name;
            fileDescriptor.markOld();
            var record = new recordType();
            // @ts-ignore
            record[fileDescriptorKey] = fileDescriptor;
            this.recordIndex[file.name] = { descriptor: fileDescriptor, record: record };
            records.push(record);
            if (options.uploadBatchKey) {
                // @ts-ignore
                record[options.uploadBatchKey] = this;
            }
        }
        this.recordFileIdKey = options.fileDescriptorIdKey;
        return records;
    };
    /**
     * Set the file descriptor ids on the records created in createRecords().
     * @param files File info returned from the server.
     */
    FileUploadBatch.prototype.processResponse = function (files) {
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            var recordInfo = this.recordIndex[file.fileName];
            recordInfo.descriptor.fileDescriptorId = file.fileDescriptorId;
            if (this.recordFileIdKey) {
                recordInfo.record[this.recordFileIdKey] = file.fileDescriptorId;
            }
        }
    };
    FileUploadBatch.prototype.toString = function () {
        return this.files.length === 1 ? this.files[0].name : "".concat(this.files.length, " files");
    };
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], FileUploadBatch.prototype, "uploadPercent", void 0);
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], FileUploadBatch.prototype, "isComplete", void 0);
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], FileUploadBatch.prototype, "uploadError", void 0);
    FileUploadBatch = __decorate([
        NeoModel,
        __metadata("design:paramtypes", [Object])
    ], FileUploadBatch);
    return FileUploadBatch;
}());
export { FileUploadBatch };
